import CraftFilterBlock from "./craft-filter-block";

import "./craft-blocks.scss";


const CraftBlocks = {
    Filter : CraftFilterBlock
};

export default CraftBlocks;